// extracted by mini-css-extract-plugin
export default {"fullPageLoader":"UrkXV08mVr8Z_39UCJlb","pulse":"ssJ28YxmfyTtuAleX7Pw"};